<template>
  <vz-card class="vz-multi-order-total-dispatch">
    <div class="vz-personal-order-total-card-item pt-30">
      <div class="text-h1 flex flex-space-between">
        Отправление
        <vz-button
          v-if="hasToggle"
          :icon-name="toggleIcon"
          rounded
          @click="visible = !visible"
        />
      </div>
      <div v-if="visible" class="vz-multi-order-total-dispatch-data">
        <div>
          <b>Откуда</b>
          <div>
            <vz-icon v-bind="dispatchIconOptions" class="mr-5" size="16" />
            <span>{{ dispatchText }}</span>
          </div>
        </div>
        <div>
          <b>Отправитель</b>
          <div>
            <vz-icon v-bind="customerIconOptions" class="mr-5" size="16" />
            <span>{{ customerText }}</span>
          </div>
        </div>
        <div>
          <b>Время</b>
          <div>
            <b class="mr-10">{{ date }}</b>
            <span class="color-light">{{ time }}</span>
          </div>
        </div>
      </div>
    </div>
  </vz-card>
</template>

<script setup lang="ts">
import VzCard from '~/components/ui-kit/vz-card.vue';
import VzButton from '~/components/ui-kit/vz-button.vue';
import {useOrderStore} from '~/stores/order';
import {storeToRefs} from 'pinia';
import VzIcon from '~/components/ui-kit/vz-icon.vue';
import {useCityStore} from '~/stores/city';
import {asyncComputed} from '@vueuse/core';
import {formatDate} from '~/common/date';

const props = defineProps({
  hasToggle: {
    type: Boolean,
    default: true
  },
})

const emit = defineEmits(['send-form'])

const { orderForm } = storeToRefs(useOrderStore())
const { multiOrder } = useOrderStore()
const cityStore = useCityStore()

const visible = ref(true)

const toggleIcon = computed(() => {
  return visible.value ? 'chevron-up' : 'chevron-down'
})

const dispatchIconOptions = computed(() => {
  switch (orderForm.value.directions.dispatch.direction) {
    case 'address':
      return { name: 'home', variant: 'primary' }
    case 'terminal':
      return { url: '/svg/vz-terminal-red.svg', noMaskedIcon: true }
    case 'pickupPoint':
      return { url: '/svg/vz-hand-cargo.svg', noMaskedIcon: true }
  }
})

const customerIconOptions = computed(() => {
  switch (orderForm.value.customer.dispatch.type) {
    case 'individual':
      return { name: 'account', variant: 'primary' }
    case 'corporation':
      return { name: 'domain', variant: 'primary' }
  }
})

const dispatchText = asyncComputed(async () => {
  return (await cityStore.locationByGuid(orderForm.value.directions.dispatch.locationGuid))?.name
}, '')

const customerText = computed(() => {
  switch (orderForm.value.customer.dispatch.type) {
    case 'individual':
      return orderForm.value.customer.dispatch.individual.name.value
    case 'corporation':
      return orderForm.value.customer.dispatch.corporation.companyName.value
  }
})

const date = computed(() => {
  return formatDate(orderForm.value.directions.dispatch.calendar.date)
})

const time = computed(() => {
  if (orderForm.value.directions.dispatch.direction === 'address') {
    return [
      orderForm.value.directions.dispatch.calendar.from,
      orderForm.value.directions.dispatch.calendar.to
    ].join('-')
  }
  return orderForm.value.directions.dispatch.calendar.terminalTime
})
</script>

<style lang="scss" scoped>
.vz-multi-order-total-dispatch {
  &-data {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 15px;
    font-size: $fs-14;
    line-height: 16px;

    b {
      font-weight: 500;
    }
    > div > div {
      margin-top: 5px;
    }
  }
}
</style>
